import { ModuleFE_FHIRResourceParam } from './ModuleFE_FHIRResourceParam.js';
export const ModulePackFE_FHIRResourceParamDB = [ModuleFE_FHIRResourceParam];
//# sourceMappingURL=module-pack.js.map